<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>  
              <Header :title="'Learning material'" :subtitle="'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here.'" />
              <Tutor :buttonName="'Book a Tutor'" v-if="has_tutor_products"/>
              <v-row>
                <v-col cols='12' sm='8' md='8'>
                  <v-expansion-panels v-if="courses.length > 0">
                    <v-expansion-panel class="mb-5" v-for="(coursedata, index) in courses" :key="index" @click="getDocuments(coursedata.course_id)">
                      <v-expansion-panel-header>{{ coursedata.course_name }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" md="6" offset-md="6">
                            <v-text-field
                              outlined
                              autocomplete="off"
                              :label="'Search learning material' | translate"
                              :ref="'search'+coursedata.course_id"
                              @keyup="search('search'+coursedata.course_id, coursedata.course_id)"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <Progress v-if="loadingdata" />
                        <template v-else>
                          <template v-if='Object.keys(generaldocuments).length > 0 && routerenter == false && loadingdata ==false'>
                            <v-expansion-panels v-for="(item,key) in generaldocuments" :key="key+''+index">
                                <v-expansion-panel class="mb-5">
                                  <v-expansion-panel-header>{{ (key == '' ? 'Undefined' : key) | translate}}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-list>
                                          <v-list-item
                                            v-for="itemdata in item"
                                            :key="itemdata.hash_id"
                                          >
                                            <v-list-item-content>
                                              <v-list-item-title v-text="itemdata.gendoc_name"></v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                              <v-btn small :color="primary_color" class="white--text" @click='openDocument(itemdata.hash_id)'>
                                                {{'View' | translate}}
                                              </v-btn>
                                            </v-list-item-action>
                                          </v-list-item>
                                        </v-list> 
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                          </template>
                          <template v-else-if="Object.keys(generaldocuments).length == 0 && routerenter == false && loadingdata ==false">
                            <h4>{{ 'No Learning material found' | translate }}</h4>
                          </template>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <h4 v-else-if="courses.length == 0 && loadingdata == false && routerenter == false ">{{ 'Please subscribe to a course' | translate }}</h4>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_COURSES, FETCH_GENERAL_DOCUMENTS , RESET_STATE } from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "Documents",
  beforeRouteEnter(to, from, next) {
    Promise.all([
       store.dispatch(RESET_STATE),
       store.dispatch(FETCH_COURSES,"?is_subscribed=true")
      ]).then(() => {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)

      })
    return next();
  },

  computed: {
    ...mapGetters(['courses','loadingdata','generaldocuments', 'routerenter','currentUser'])
  },
  components: {
    Progress: () => import("@/components/progress/progress"),
    Header: () => import("@/components/header/Header"),
    Tutor: () => import("@/components/modal/Tutor")
  },
  data() {
    return {
      primary_color:null,
      has_tutor_products:false,
    };
  },
  mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color

     if(company_meta.hasOwnProperty('has_tutor_products')){
      this.has_tutor_products = (company_meta.has_tutor_products==='true')
    }
  },
  methods: {
    async getDocuments(id){
      await this.$store.dispatch(FETCH_GENERAL_DOCUMENTS,'?course_id='+id+'&group_by=section_header').then(resp =>{
        if(resp != undefined && resp.success == true){
          this.$store.commit(SET_LOADING,false)
        }else{
          this.$store.commit(SET_LOADING,false)
        }
      })
    },
    async search(searchvalue,courseid){
      let searchdata = (this.$refs[searchvalue] == undefined ? '': (this.$refs[searchvalue][0].internalValue == undefined ? '' :this.$refs[searchvalue][0].internalValue))
      await this.$store.dispatch(FETCH_GENERAL_DOCUMENTS,'?course_id='+courseid+'&group_by=section_header&search='+searchdata).then(() => {
        store.commit(SET_LOADING, false)
      });
    },
    openDocument(hashid){
      this.$router.push('/learningmaterial/'+hashid)
    }
  }

}
</script>
